import { create } from 'zustand';

export interface User {
  id: string;
  name: string;
  ldapId: string;
  telephoneNumber: string;
  mailAddress: string;
  organizationCode: string;
  branchCode: string;
  salesOfficeCode: string;
  sectionCode: string;
  squadCode: string;
  jobPosition: string;
  positionName: string;
  locationUpdateDate: Date;
  location: {
    latitude: number;
    longitude: number;
  };
}

export interface UserState {
  user: User | null;
  selectedUser: User | null;
  users: User[];
  availableWorkers: User[];
  setUser: (user: User | null) => void;
  setSelectedUser: (selectedUser: User | null) => void;
  setUsers: (users: User[]) => void;
  setAvailableWorkers: (availableUsers: User[]) => void;
}

export const useWaUserStore = create<UserState>()((set) => ({
  user: null,
  selectedUser: null,
  users: [],
  availableWorkers: [],
  setUser: (user) => {
    set({ user });
  },
  setSelectedUser: (selectedUser) => {
    set({ selectedUser });
  },
  setUsers: (users) => {
    set({ users: users });
  },
  setAvailableWorkers: (availableUsers) => {
    set({ availableWorkers: availableUsers });
  },
}));
